import CountdownFonts from 'client/components/core/Sidebar/components/Settings/entities/Countdown/components/CountdownFonts'
import CountdownOptions from 'client/components/core/Sidebar/components/Settings/entities/Countdown/components/CountdownOptions'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import DeviceAppearanceNew from 'client/components/core/Sidebar/components/Settings/options/DeviceAppearance/DeviceAppearanceNew'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { CountdownInterface } from 'common/types/entities/CountdownInterface'
import React from 'react'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'

interface CountdownSettingsProps {
  entity: CountdownInterface
  defaultEntity?: CountdownInterface
}

const CountdownSettings = ({
  entity,
  defaultEntity,
}: CountdownSettingsProps) => {
  const updateProp = useUpdateProp(entity)
  const { isMobile } = useDeviceModeContext()
  return (
    <>
      <CountdownOptions entity={entity} />
      <CountdownFonts entity={entity} defaultEntity={defaultEntity} />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default CountdownSettings
